export const Urls = {
    WesternBidUserAgreementFile:"https://westernbid.link/western-bid-in-english/wbuseragreement.pdf",
    WesternBidPrivacyPolicyFile: "https://westernbid.link/western-bid-in-english/pp.pdf",
    WesternBidShippingAndHandlingPolicyFile: "https://westernbid.link/western-bid-in-english/sh.pdf",
    WesternBid: "https://westernbid.com",
    WestParcel: "https://westparcel.com",
    WestParcelPL: "https://westparcel.pl",
    WestParcelCZ: "https://westparcel.cz",
    GetHelp: "https://westernbid.com/en/articles/help"
};